import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShoppingBag, Eye, Download } from 'lucide-react';
import { useCart } from './context/CartContext';
import './ProductCard.css';

const ProductCard = ({ product }) => {
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const [isHovered, setIsHovered] = useState(false);

  const handleAddToCart = (e) => {
    e.stopPropagation();
    addToCart(product);
  };

  const handleCardClick = () => {
    navigate(`/product/${product.id}`);
  };

  const getTypeIcon = () => {
    return product.type === 'digital' ? <Download size={14} /> : <Eye size={14} />;
  };

  return (
    <div 
      className="product-card"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleCardClick}
    >
      <div className="card-inner">
        <div className="product-image-wrapper">
          <img 
            src={product.image} 
            alt={product.title}
            className="product-image"
          />
          
          {/* Overlay */}
          <div className={`product-overlay ${isHovered ? 'overlay-visible' : ''}`}>
            <div className="overlay-actions">
              <button 
                className="overlay-btn" 
                title="Quick View"
                onClick={(e) => e.stopPropagation()}
              >
                <Eye size={20} />
              </button>
            </div>
          </div>

          {/* Type Badge */}
          <div className="product-type">
            {getTypeIcon()}
            <span>{product.type}</span>
          </div>
        </div>

        <div className="product-info">
          <div className="product-header">
            <div>
              <h3 className="product-title">{product.title}</h3>
              <p className="product-artist">{product.artist}</p>
            </div>
          </div>

          <div className="product-footer">
            <div className="price-wrapper">
              <span className="price">${product.price}</span>
              {product.originalPrice && (
                <span className="original-price">${product.originalPrice}</span>
              )}
            </div>
            
            <button 
              className="add-to-cart-btn"
              onClick={handleAddToCart}
            >
              <ShoppingBag size={16} />
              <span>Add</span>
            </button>
          </div>
        </div>
      </div>

      {/* Card Glow Effect */}
      <div className="card-glow"></div>
    </div>
  );
};

export default ProductCard;